'use strict';

angular.module('TurneroApp').service('gruposService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/GrupoPuesto/:id', { id: '@Id_Grupo' }, {
        query: {
            method: 'GET',
            isArray: true
        },
        getInfo: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion',
                id_Grupo: 'id_Grupo'
            },
            url: portal.getUrlServer() + 'api/GrupoPuesto/getInfo/'
        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            params: {
                id_Centro_Atencion: '@id_Centro_Atencion',
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        save: {
            method: 'POST'
        },
        'delete': {
            method: 'DELETE'
        },
        update: {
            method: 'PUT'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/grupos/gruposService.js